export default "__VITE_ASSET___EO_uzKW__"